import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { options, weedSprayOptions } from './constants';

const selectSprayMethodOptions = createDeepEqualSelector(
    selectSprayEventTypeIsWeed,
    (sprayEventTypeIsWeed) =>
        sprayEventTypeIsWeed ? weedSprayOptions : options
);

export { selectSprayMethodOptions };
